import Components from "../components";

class ProjectForm extends Components.Base {
  initialize() {
    this.button = this.$el.find('input[type=submit]');
    this.userId = this.$el.find('#project_user_id').val();
    this.toggleWarning();
  }

  bind() {
    this.on('change', '#project_user_id', e => this.doToggles(e));
  }

  doToggles(e) {
    this.userId = $(e.currentTarget).val();
    this.toggleTeam();
    this.toggleWarning();
  }

  toggleTeam() {
    // Show/hide teams based on the chosen user
    this.$el
      .find('.team-list')
      .hide()
      .find('input')
      .prop('disabled', true);
    this.$el
      .find(`#user_${this.userId}_teams`)
      .show()
      .find('input')
      .prop('disabled', false);
  }

  toggleWarning() {
    // Show a warning if the user has reached his project limit
    this.$el.find('.limit_warning').hide();
    const $warning = $(`#limit_${this.userId}`);
    if ($warning.length > 0) {
      $warning.show();
      this.button.prop('disabled', true);
    } else {
      this.button.prop('disabled', false);
    }
  }
}

Components.collection.register({
  selector: '.c-project-form',
  klass: ProjectForm,
});
